module.exports = __webpack_public_path__ + "static/media/ic-drawer-store-management.3c3310b1.svg";